import { useEffect } from "react";
import { Link } from "react-router-dom";
import { CheckCircle2, HardHat } from "lucide-react";
import { APP_NAME } from "@crewledger/shared/constants";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { InfoBanner } from "@/components/design/info-banner";

export function RequestAccessSuccessPage() {
  useEffect(() => {
    document.title = `Request received — ${APP_NAME}`;
  }, []);

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-6">
      <Card className="w-full max-w-lg">
        <CardHeader className="text-center">
          <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-lg bg-primary text-primary-foreground">
            <HardHat className="h-6 w-6" />
          </div>
          <CardTitle>Request received</CardTitle>
          <CardDescription>We&apos;ll be in touch if your beta access is approved.</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          <InfoBanner icon={CheckCircle2} variant="success">
            Thanks — your request was received. If approved, you&apos;ll receive access to create a
            real Werkio workspace.
          </InfoBanner>
          <Link to="/login" className="block">
            <Button className="w-full" variant="outline">
              Back to sign in
            </Button>
          </Link>
          <p className="text-center text-sm text-muted-foreground">
            <Link to="/demo" className="font-medium text-orange-construction hover:underline">
              Try the demo
            </Link>
            {" · "}
            <Link to="/" className="font-medium hover:underline">
              Home
            </Link>
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
